import { createI18n } from "vue-i18n";
import en from './locales/en.json'
import fr from './locales/fr.json'
import nl from './locales/nl.json'

const i18n = createI18n({
  legacy: false,
  locale: 'en',
  fallbackLocale: 'en',
  messages: {
    en,
    fr,
    nl
  },
  globalInjection: true,
  allowComposition: true
});

export function setI18nLanguage(lang: string) {
  i18n.global.locale.value = lang;
  document.querySelector("html")?.setAttribute("lang", lang);
  localStorage.setItem('language', lang);
  return lang;
}

export function loadStoredLanguage() {
  const storedLang = localStorage.getItem('language');
  if (storedLang) {
    setI18nLanguage(storedLang);
  }
}

export default i18n;
